import { render, staticRenderFns } from "./CopyPage.vue?vue&type=template&id=61284228"
import script from "./CopyPage.vue?vue&type=script&lang=js"
export * from "./CopyPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports